var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading-placeholder-container",class:{'overlay-mode': _vm.overlay},style:({'min-height': `${_vm.minHeight}px`})},[_c('spinner',{staticClass:"loading-spinner",style:({'width': `${_vm.radius}px`, 'height': `${_vm.radius}px`})})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }